import React, { Component } from "react";
import Image from '../global/Image';
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

export default class PageMrkSubscription extends Component {
  	
  	constructor(){
		super()
		this.state = {
			submitted: false
		}
		this.submitSuccess = this.submitSuccess.bind(this);
	}
	
	submitSuccess() {
		if (this.formThanks) {
			this.formThanks.click();
		}
  	}
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    
			    	<div className="c-mrk-usps">
			    
				    	<div className="l-content l-content--fixed-width">
				    		
				    		<div className="l-grid">
								
								{block.form_id &&
									<div className="l-grid__col">
										<div className="scope-sub-form">
											<GravityForm
												backendUrl={document.location.origin + '/wp-json/castran/v1/form'}
												formID={block.form_id}
												onSubmitSuccess={this.submitSuccess}
											/>
										</div>
										{block.form_confirm_url &&
											<Link to={{ pathname: block.form_confirm_url }} ref={e => (this.formThanks = e)} style={{display:'none'}}></Link>
										}
									</div>
								}
				    			
				    		</div>
				    		
				    	</div>
			    	
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
